/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef, useId } from 'react';
import { ErrorText, Input, Label } from './MerchantSignupPage.styles';

interface TextFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'id'> {
    label: string;
    /** Shown under the input with role="alert" and linked to it. */
    error?: string;
}

/** A labelled input with its inline error, styled for the signup card. The ref goes to the input. */
const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
    ({ label, error, ...inputProps }, ref) => {
        const id = useId();
        const errorId = `${id}-error`;

        return (
            <div>
                <Label htmlFor={id}>{label}</Label>
                <Input
                    ref={ref}
                    id={id}
                    aria-invalid={Boolean(error)}
                    aria-describedby={error ? errorId : undefined}
                    {...inputProps}
                />
                {error && (
                    <ErrorText id={errorId} role="alert">
                        {error}
                    </ErrorText>
                )}
            </div>
        );
    }
);

TextField.displayName = 'TextField';

export default TextField;
